var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"programComp"},[_c('nav-local-comp',{attrs:{"all":'Программы',"id":_vm.id,"toAll":_vm.toAll}}),_c('program-crud-comp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }